export default __webpack_public_path__ + "static/media/icon-park-outline_data-user.68d72289.svg";